import React from "react";

class RegistrationForm extends React.Component {
  state = {
    valid: false,
    validationMessage: null,
  };

  onHandleSubmit = (e) => {
    e.preventDefault();

    const data = {
      firstname: this.firstNamelInput.value,
      lastname: this.lastNamelInput.value,
      name: this.emailInput.value,
      email: this.emailInput.value,
      password: this.passwordInput.value,
      repeatPassword: this.repeatPasswordInput.value,
    };

    this.validateInput(data);
  };

  validateInput = (data) => {
    if (
      !data.firstname ||
      !data.lastname ||
      !data.name ||
      !data.email ||
      !data.password ||
      !data.repeatPassword
    ) {
      this.setState({
        valid: false,
        validationMessage: "Please make sure there are no empty fields.",
      });
    } else if (data.password !== data.repeatPassword) {
      this.setState({
        valid: false,
        validationMessage: "Password fields do not match.",
      });
    } else {
      this.props.handleRegisterUser(data);
    }
  };

  render() {
    if (this.props.registrationSuccess) {
      this.props.showLoginForm();
    }

    return (
      <div className="login-prompt__form">
        <h3 className="login-prompt__header">Create a New Account</h3>

        <form action="" onSubmit={this.onHandleSubmit}>
          {!this.state.valid && (
            <p className="upload__login-error">
              {this.state.validationMessage}
            </p>
          )}

          {this.props.registerError && (
            <p className="upload__login-error">
              There was an error. Please check the form and submit again.
            </p>
          )}

          <div className="upload__input">
            <input
              type="text"
              name="first_name"
              ref={(input) => {
                this.firstNamelInput = input;
              }}
            />
            <label>First Name</label>
          </div>

          <div className="upload__input">
            <input
              type="text"
              name="last_name"
              ref={(input) => {
                this.lastNamelInput = input;
              }}
            />
            <label>Last Name</label>
          </div>

          <div className="upload__input">
            <input
              type="email"
              name="email"
              ref={(input) => {
                this.emailInput = input;
              }}
            />
            <label>Email</label>
          </div>

          <div className="upload__input">
            <input
              type="password"
              name="password"
              ref={(input) => {
                this.passwordInput = input;
              }}
            />
            <label>Password</label>
          </div>

          <div className="upload__input">
            <input
              type="password"
              name="repeat-password"
              ref={(input) => {
                this.repeatPasswordInput = input;
              }}
            />
            <label>Repeat Password</label>
          </div>

          <div className="upload__forgot-pass">
            Already have an account?
            <span
              className="link link--register"
              onClick={this.props.showLoginForm}
            >
              Login
            </span>
          </div>

          <button
            className="button button--round button--login-prompt"
            type="submit"
          >
            Register
          </button>
        </form>
      </div>
    );
  }
}

export default RegistrationForm;
